__turbopack_context__.v({
  "card": "all-in-one-calculator-module-scss-module__JnhXXa__card",
  "checkouts-disabled": "all-in-one-calculator-module-scss-module__JnhXXa__checkouts-disabled",
  "confirmation-row": "all-in-one-calculator-module-scss-module__JnhXXa__confirmation-row",
  "input-grid": "all-in-one-calculator-module-scss-module__JnhXXa__input-grid",
  "input-row-1": "all-in-one-calculator-module-scss-module__JnhXXa__input-row-1",
  "input-row-2": "all-in-one-calculator-module-scss-module__JnhXXa__input-row-2",
  "placeholder": "all-in-one-calculator-module-scss-module__JnhXXa__placeholder",
  "section": "all-in-one-calculator-module-scss-module__JnhXXa__section",
  "solar-teaser": "all-in-one-calculator-module-scss-module__JnhXXa__solar-teaser",
  "unit": "all-in-one-calculator-module-scss-module__JnhXXa__unit",
});
